import React, { useContext } from "react";
import MetaTags from "react-meta-tags";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Col, Container, Row } from "reactstrap";
import Inboxes from "./Inboxes";
import { ThemeContext } from "src/helpers/themeContext";

const InboxesPage = () => {
    const Theme = useContext(ThemeContext)
    return (
        
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Inboxes | {Theme.name} inboxes</title>
                </MetaTags>

                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Home" breadcrumbItem="Inboxes" />

                    <Row>
                        <Col lg={12}>
                            <Inboxes />
                        </Col>
                    </Row>

                    
                </Container>
            </div>
        </React.Fragment>
    );
}

export default InboxesPage;